<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>
    <form class="sdev-form" @submit.prevent="submit">

        <div class="sdev-form-field">
            <label class="sdev-form-label">Key</label>
            <input class="sdev-input" v-model="local.identity_key" />
        </div>

        <div class="sdev-form-field">
            <label class="sdev-form-label">Name</label>
            <input class="sdev-input" v-model="local.identity_name" />
        </div>

        <div class="sdev-form-field">
            <label class="sdev-form-label">Type</label>
            <input class="sdev-input" v-model="local.identity_type" />
        </div>

        <div class="sdev-form-actions">
            <button class="sdev-button sdev-bg-surface-elevated" type="submit">
                Save
            </button>
        </div>

    </form>

</template>



<script setup>

import { reactive, watch } from "vue"

const props = defineProps({
    model: Object
})

const emit = defineEmits(["submit"])

const local = reactive({})

watch(
    () => props.model,
    (v) => Object.assign(local, v || {}),
    { immediate: true }
)

function submit() {
    emit("submit", { ...local })
}

</script>